@app.service 'stripeService', (AnalyticsService, PricingService, localStorageService, ModalService, utilities, $window, $http, $location, LocationService, $state) ->

  @showCheckout = (sku, user, isGift, bypassInternational=false)=>
    if (! PricingService.askInternationalOverride(sku)) || bypassInternational
      priceData = PricingService.getPrice(sku, {userIsPremium: user.premium, usedCirculatorDiscount: user.used_circulator_discount})

      analyticsProperties = _.extend({gift: isGift}, priceData)
      analyticsProperties.price = analyticsProperties.price / 100
      analyticsProperties.tax = analyticsProperties.tax / 100
      analyticsProperties.msrp = analyticsProperties.msrp / 100
      analyticsProperties.totalPrice = analyticsProperties.totalPrice / 100
      analyticsProperties.quantity = 1
      analyticsProperties.name = priceData.title

      AnalyticsService.track 'Added Product', analyticsProperties

      taxRate = LocationService.location.taxPercent

      label = "Pay #{utilities.penniesToCurrency(priceData.price)}"
      label += " + #{utilities.penniesToCurrency(@getTaxPrice(priceData.price, taxRate))} Tax" if taxRate? > 0

      $window.stripeHandler.open
        name: 'ChefSteps, Inc.'
        image: 'https://d3awvtnmmsvyot.cloudfront.net/api/file/LLsyWzeCR5qBPIHk7qQo'
        panelLabel: label
        description: if isGift then priceData.title + " (Gift)" else priceData.title
        # Don't pass the amount - it is display only, see panelLabel above.
        #amount:
        zipCode: true
        shippingAddress: priceData.shippable
        billingAddress: true
        email: user.email

        closed: (x) =>
          if @stripeToken
            ModalService.open('waiting')

        token: (token, args) =>
          @stripeToken = token

          # TODO dry these two lines up - in services
          userToken = localStorageService.get('user.token')
          headerParams = { 'Authorization': 'Bearer ' + userToken, "x-csrf-token":undefined }

          urlParams = $location.search()
          args = _.extend(args, urlParams)
          premiumOnlyPurchase = sku == 'cs10002'
          joulePurchase = sku == 'cs10001'

          $http(
            method: 'POST'
            headers: headerParams
            params:
              _.extend(args,
                stripeToken: token.id
                sku: sku
                gift: isGift
                price: priceData.price
                tax: priceData.tax
              )
            url: '/api/v0/charges'

          ).success((data, status, headers, config) ->
            console.log "STRIPE CHARGE WIN"

            if joulePurchase
              $state.currentUser.used_circulator_discount = true

            if ! isGift
              # Either Joule or Premium, optimistically make them premium. Stored in two places :(.
              $state.currentUser.premium = true if $state.currentUser
              app.currentUser.premium = true if app.currentUser

            extraText = ""
            extraText = "" if joulePurchase

            dollarPrice = priceData.price / 100.0

            AnalyticsService.track 'Completed Order Client-Side',
              product_skus: [sku],
              revenue: dollarPrice,
              shipping: 0,
              gift: isGift,
              currency: 'USD'

            if ! isGift
              ModalService.open('buyResult',
                type: "normal"
                description: priceData.title
                buttonText: if premiumOnlyPurchase then "Let's Get Started" else "OK"
                extraText: extraText
              ).then ->
                if premiumOnlyPurchase
                  if $state.current.name == 'main.activity'
                    # If looking at a paywalled activity, reload to remove the paywall
                    window.location.reload()
                  else
                    # Otherwise take 'em to /premium where they learn of all the wonderful benefits of premium
                    $state.go 'main.pages', {id: 'premium'}, reload: true
                else
                  $state.go $state.current, {}, reload: true

            else
              ModalService.open('buyResult',
                type: "gift"
                description: priceData.title
                extraText: extraText
              ).then ->
                window.location.reload() if ! premiumOnlyPurchase

          ).error((data, status, headers, config) ->
            AnalyticsService.track 'Buy Button Error', _.extend(analyticsProperties, error: data.error)
            console.log "STRIPE CHARGE FAIL", data
            ModalService.open('buyResult', { type: "error", message: data.error})
          )

    else
      ModalService.open('internationalJoule', {type: 'normal', sku: sku, user: user, isGift: isGift})

  @getTaxPrice = (price, rate) ->
    utilities.roundTo(price*rate, 2)

  this
